"use strict";

module.exports = {
  ColorConverters: require('./ColorConverters').default,
  ColorWorker: require('./ColorExtractor.worker')
};